import React, {Component} from 'react';
import Input from "../../elements/components/form/Input";

export default class PriceForNightFilter extends Component {
    render() {
        const {translations, onChangeFilter} = this.props;

        return (
            <div className="filter-with-title">
                <div className="filter-title">
                    {translations['price-for-night']}
                </div>
                <div className="filter-price">
                    <Input
                        id="priceMin"
                        type='number'
                        placeholder={translations['input-from']}
                        onChange={value => {
                            onChangeFilter({priceMin: value})
                        }}
                        className="form-controller"
                        max={6}
                    />

                    <Input
                        id="priceMax"
                        type='number'
                        placeholder={translations['input-to']}
                        onChange={value => {
                            onChangeFilter({priceMax: value})
                        }}
                        className="form-controller"
                        max={6}
                    />
                </div>
            </div>
        )
    }
}